import React from 'react'
import classNames from 'classnames'

interface InlineTextInputProps {
    value: string
    onChange: (value: string) => void
    onBlur?: (value: string) => void
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    placeholder?: string
    disabled?: boolean
    className?: string
}

/**
 * Borderless, transparent text input for inline editing of names/titles.
 *
 * Pass a `className` to control size and weight — two common variants:
 *
 *   Title (h1-level):
 *     "text-[40px] font-bold tracking-[-0.04em] leading-none placeholder:text-[#CDD6DF] -ml-0.5"
 *
 *   Inline field (settings row):
 *     "text-sm font-medium placeholder:text-[#94A3B8] placeholder:italic"
 */
export const InlineTextInput = ({
    value,
    onChange,
    onBlur,
    onKeyDown,
    placeholder,
    disabled,
    className,
}: InlineTextInputProps) => (
    <input
        type="text"
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur ? (e) => onBlur(e.target.value) : undefined}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        className={classNames(
            'w-full bg-transparent border-none outline-none text-[#0E2947] focus:ring-0 p-0',
            className,
        )}
    />
)
